<template>
  <v-pagination
    outlined
    style="background: transparent;"
    :color="$theme.primary"
    total-visible="7"
    v-model="get_notifications_filtros.page"
    :length="get_notifications.totalPages"
    @input="setPage($event)"
  ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_notifications", "get_notifications_filtros"])
  },
  methods: {
    ...mapActions(["listar_notifications"]),
    setPage(page) {
      if (page) {
        console.log("page", page);
        this.get_notifications_filtros.page = page;
        this.listar_notifications();
      }
    }
  }
};
</script>
